























import { Component, Vue, Prop } from "vue-property-decorator";
import { EventService } from "@/services/eventService";

@Component
export default class EventSignupComplete extends Vue {
    @Prop() registrationId!: string;

    public async getICS() {
        const ics = await EventService.getICSbyRegistration(
            this.registrationId
        );
        const blob = new Blob([ics.data], { type: "text/plain" });
        const fileURL = window.URL.createObjectURL(blob);
        const fileLink = document.createElement("a");

        fileLink.href = fileURL;
        const matches = ics.headers["content-disposition"].match(/"(.*?)"/);
        fileLink.setAttribute(
            "download",
            `${matches ? matches[1] : "event.ics"}`
        );
        document.body.appendChild(fileLink);

        fileLink.click();
    }
}
